import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const axios = process.env.NODE_ENV === 'development'
  ? require('axios').create({ baseURL: 'http://localhost:3000' })
  : require('axios').create()

export default new Vuex.Store({
  state: {
    questlist: [
    ],
    quest: {
      name: 'name',
      prerequisite_quest: [
        {
          name: 'name',
          quest_id: 1
        }
      ],
      subsequent_quest: [
        {
          name: 'name',
          quest_id: 1
        }
      ],
      reward_base: {
        nenryo: 0,
        danyaku: 0,
        kozai: 0,
        bauxite: 0
      }
    },
    periodFilters: [
      'daily',
      'weekly',
      'monthly',
      'quarterly',
      'yearly',
      'once'
    ],
    typeFilters: [
      'factory',
      'sortie',
      'exercise',
      'expedition',
      'supply',
      'arsenal',
      'refurbishment'
    ],
    limitedFilters: [
      'permanent',
      'limited',
      'finished'
    ],
    questSort: 'sortDateDesc',
    newFlag: false,
    canContact: true,
    searchItemList: [
      {
        item_id: 'item_id',
        item_type: 'item_type',
        weapon_type: 'weapon_type',
        item_name: 'item_name'
      }
    ],
    limitedFlg: 0,
    finishedFlg: 0
  },
  getters: {
    getQuests: state => {
      return state.questlist
    },
    getModalQuest: state => {
      return state.quest
    },
    isNew: state => {
      return state.newFlag
    },
    canContact: state => {
      return state.canContact
    },
    getSearchItemList: state => {
      return state.searchItemList
    }
  },
  mutations: {
    fetchQuests (state) {
      let param = ''
      state.periodFilters.forEach(filter => (param = param + 'period_filter=' + filter + '&'))
      state.typeFilters.forEach(filter => (param = param + 'type_filter=' + filter + '&'))
      state.limitedFilters.forEach(filter => (param = param + 'limited_filter=' + filter + '&'))
      var searchItems = JSON.parse(localStorage.getItem('searchItem'))
      if (searchItems !== null) {
        searchItems.forEach(items => (param = param + 'search_items=' + items + '&'))
      }
      param = param + 'quest_sort=' + state.questSort + '&'
      axios
        .get('/api/questlist?' + param)
        .then(function (response) {
          state.questlist = response.data
          state.questlist.forEach(function (quest) {
            quest.is_achieved = localStorage.getItem('achieved-' + quest.quest_id) != null
          })
          state.questlist.forEach(quest => (console.log(quest)))
        })
    },
    setModalQuest (state, questId) {
      let questJson = localStorage.getItem(questId)
      if (questJson) {
        let questTmp = JSON.parse(questJson)
        questTmp.is_achieved = localStorage.getItem('achieved-' + questTmp.quest_id) != null
        state.quest = questTmp
      } else {
        axios
          .get('/api/quest/' + questId)
          .then(function (response) {
            let quest = process.env.NODE_ENV === 'development' ? response.data[0] : response.data
            quest.is_achieved = localStorage.getItem('achieved-' + quest.quest_id) != null // 初期はnullのはずだが検証のため
            localStorage.setItem(questId, JSON.stringify(quest))
            state.quest = quest
          })
      }
    },
    updatePeriodFilter (state, filters) {
      state.periodFilters = filters
    },
    updateTypeFilter (state, filters) {
      state.typeFilters = filters
    },
    updateLimitedFilter (state, filters) {
      state.limitedFilters = filters
    },
    updateQuestSort (state, sort) {
      state.questSort = sort
    },
    checkAppVersion (state, appVersion) {
      if (localStorage.appVersion) {
        let lsAppVersion = localStorage.appVersion
        state.newFlag = lsAppVersion !== appVersion
      } else {
        state.newFlag = true
      }
      localStorage.appVersion = appVersion
    },
    checkDbVersion (state, dbVersion) {
      if (localStorage.dbVersion) {
        let lsDbVersion = localStorage.dbVersion
        if (lsDbVersion !== dbVersion) {
          // 指定questのローカルストレージ削除
          // ローカルストレージのdbVersionとの差分で更新をかける
          // 削除対象のquest_idリストを記載したjsonファイルを展開
          const data = require('../datas/reset.json')
          // リストを処理していく
          data.forEach(function (idList) {
            // ローカルストレージのdbVersionより大きいversionを持ったリストが来た場合対象を削除
            if (idList.version > lsDbVersion) {
              idList.ids.forEach(function (questId) {
                localStorage.removeItem(questId)
              })
            }
          })
        }
      } else {
        // ローカルストレージ全クリア
        localStorage.clear()
      }
      localStorage.dbVersion = dbVersion
    },
    offNewFlag (state) {
      state.newFlag = false
    },
    checkContactCount (state) {
      let date = new Date()
      let now = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate()
      if (localStorage.contactDate) {
        // 今日じゃなかったらカウント0
        if (localStorage.contactDate !== now) {
          localStorage.contactDate = now
          localStorage.contactCount = 0
        }
      } else {
        localStorage.contactDate = now
      }

      if (!localStorage.contactCount) {
        localStorage.contactCount = 0
      }

      state.canContact = localStorage.contactCount < 5
    },
    updateContactCount () {
      localStorage.contactCount++
    },
    fetchSearchItemList (state) {
      axios
        .get('/api/searchitemlist')
        .then(response => (state.searchItemList = response.data))
    }
  },
  actions: {
    fetchQuests ({ commit }, filter) {
      commit('fetchQuests', filter)
    },
    setModalQuest ({ commit }, questId) {
      commit('setModalQuest', questId)
    },
    updatePeriodFilter ({ commit }, filters) {
      commit('updatePeriodFilter', filters)
    },
    updateTypeFilter ({ commit }, filters) {
      commit('updateTypeFilter', filters)
    },
    updateLimitedFilter ({ commit }, filters) {
      commit('updateLimitedFilter', filters)
    },
    updateQuestSort ({ commit }, sort) {
      commit('updateQuestSort', sort)
    },
    checkAppVersion ({ commit }, appVersion) {
      commit('checkAppVersion', appVersion)
    },
    checkDbVersion ({ commit }, dbVersion) {
      commit('checkDbVersion', dbVersion)
    },
    offNewFlag ({ commit }) {
      commit('offNewFlag')
    },
    checkContactCount ({ commit }) {
      commit('checkContactCount')
    },
    updateContactCount ({ commit }) {
      commit('updateContactCount')
    },
    fetchSearchItemList ({ commit }) {
      commit('fetchSearchItemList')
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js